import React from 'react';
import { Tag as ChakraTag, TagProps as ChakraTagProps } from '@chakra-ui/react';

export function Tag(props: ChakraTagProps) {
  return <ChakraTag {...props} />;
}
